import React from 'react';
import SetCard from '../../assets/img/setCard.jpg';

const CompanyCard = ({title, description}) => {
  return (
    <div className="border border-purple border-[2px] grid grid-cols-2 gap-[20px] rounded-[12px] min-h-[150px]">
      <div
        className=" bg-cover bg-center rounded-[10px_0px_0px_10px]"
        style={{ backgroundImage: `url(${SetCard})` }}
      ></div>
      <div className="p-[8px_8px_8px_0px] flex flex-col justify-center">
        <p className="text-white font-semibold text-[24px]">{title}</p>
        <div className='bg-purple w-full h-[2px] my-[4px]'></div>
        <p className='text-white'>{description}</p>
      </div>
    </div>
  );
};

export default CompanyCard;
